export function accessControlUtils(module) {
  try {
    const userData = localStorage?.getItem("user_access_data");
    if (!userData || userData === "undefined" || userData === "null") {
      return { create_access: false, read_access: false, update_access: false, delete_access: false };
    }
    const user_access_data = JSON.parse(userData);
    const access = user_access_data?.find(
      (acdata) => acdata?.module_name === module
    );
    // Return default access object if module not found
    return access || { create_access: false, read_access: false, update_access: false, delete_access: false };
  } catch (error) {
    console.error("Error parsing user_access_data from localStorage:", error);
    localStorage.removeItem("user_access_data"); // Clean up invalid data
    return { create_access: false, read_access: false, update_access: false, delete_access: false };
  }
}

/** True when this login's access list carries a row for the module at all (false: the server has not set the module up yet). */
export function hasAccessRow(module) {
  try {
    const userData = localStorage?.getItem("user_access_data");
    if (!userData || userData === "undefined" || userData === "null") return false;
    return Boolean(JSON.parse(userData)?.some((acdata) => acdata?.module_name === module));
  } catch (error) {
    return false;
  }
}
